import axios from "axios";


export const readOcr = async () => {
    const response = await axios.get("api/images/ocr");
    const result = response.data;
    return result;
}


export const postOcr = async (attachment) => {
    console.log ("Attachment:", attachment);
    const response = await axios.post("api/images/ocr/", attachment);
    const result = response.data;
    return result;
}